module.exports = __webpack_public_path__ + "media/images/icons/twotone/rocket-a770b6a3a0a5be0c22ed7ae135ab01e2.svg";